export const RegionAbbreviations = {
  'International': 'INTL',
  'Southeast Asia': 'SEA',
  'Latin America': 'LATAM',
  'North America': 'NA',
  'Oceania': 'OCE',
  'Korea': 'SK',
  'Japan': 'JPN',
  'Vietnam': 'VN',
  'Brazil': 'BZL'
}